import { isNativeApp, getPlatform } from "./nativeBridge";
import api from "./api";

let listenersAttached = false;
let navigateRef = null;

async function attachListeners(PushNotifications) {
  if (listenersAttached) return;
  listenersAttached = true;
  await PushNotifications.addListener("registration", async (t) => {
    try {
      localStorage.setItem("native_push_token", t.value);
    } catch {}
    try {
      await api.post("/push/register-token", { token: t.value, platform: getPlatform() });
    } catch {}
  });
  await PushNotifications.addListener("registrationError", async (err) => {
    try {
      await api.post("/push/register-error", {
        error: String(err?.error || err?.message || JSON.stringify(err) || "unknown").slice(0, 400),
        platform: getPlatform(),
      });
    } catch {}
  });
  await PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
    const link = action?.notification?.data?.link;
    if (link && link.startsWith("/")) {
      if (navigateRef) navigateRef(link);
      else window.location.href = link;
    }
  });
}

async function clearDelivered(PushNotifications) {
  try {
    await PushNotifications.removeAllDeliveredNotifications();
  } catch {}
}

/**
 * Single registration path for native push (APNs/FCM).
 * silent=true only registers when permission is already granted
 * (no prompt) — used on app launch / shell boot.
 */
export async function registerNativePush({ silent = false, navigate = null } = {}) {
  if (!isNativeApp()) return false;
  if (navigate) navigateRef = navigate;
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");
    let perm = await PushNotifications.checkPermissions();
    if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
      if (silent) return false;
      perm = await PushNotifications.requestPermissions();
    }
    if (perm.receive !== "granted") return false;
    await attachListeners(PushNotifications);
    await PushNotifications.register();
    clearDelivered(PushNotifications);
    try {
      const { App } = await import("@capacitor/app");
      App.addListener("resume", () => clearDelivered(PushNotifications));
    } catch {}
    return true;
  } catch {
    return false;
  }
}

/** App-boot path (prompts if needed). Kept for NativePushBootstrap. */
export async function initNativePush(navigate) {
  return registerNativePush({ silent: false, navigate });
}
